import { render, staticRenderFns } from "./recordings.vue?vue&type=template&id=963041de&scoped=true&"
import script from "./recordings.vue?vue&type=script&lang=js&"
export * from "./recordings.vue?vue&type=script&lang=js&"
import style0 from "./recordings.vue?vue&type=style&index=0&id=963041de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963041de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCard,VDataTable,VIcon,VSnackbar})
